export default "__VITE_ASSET__6g5SRF1S__"